export default __webpack_public_path__ + "static/assets/4e8df03eb146bd7f93b355c62450029b.svg";